import Accordion from '@material-ui/core/Accordion';

export default Accordion;
